/**
 * The board's fixed numbers and palettes, in one place: how far it zooms, how close edges snap,
 * how long another page's drag is trusted, and the colours and pen widths offered.
 */

/**
 * How far the board zooms: as far as one likes both ways (the bounds only keep the numbers
 * meaningful); "fit" never goes past 100%.
 */
export const BOARD_ZOOM = { min: 1e-4, max: 1e4, fitMax: 1 } as const;

/** How close (screen pixels) an edge must come to another's to snap to it. */
export const SNAP_PX = 6;

/** How long another page's drag is shown without news before it is dropped. */
export const STALE_MS = 4000;

/** The pen's widths (board units), thinnest first. */
export const PEN_WIDTHS = [2, 4, 8, 16] as const;

/** The pen's colours. */
export const PEN_COLOURS = ["#1d1b26", "#e03131", "#2f80ff", "#2b8a3e", "#f08c00", "#6a4be0", "#ffffff"] as const;

/** The colours offered for notes, fills and lines (Miro's sticky-note colours first). */
export const BOARD_COLOURS = ["#ffe680", "#ffc2d1", "#c7f0d8", "#cfe3ff", "#e4d7ff", "#ffd8a8", "#ffffff", "#222222", "#6a4be0", "#e03131"] as const;

/** A rectangle drawn smaller than this (board units, both ways) was a click: the new thing takes its usual size. */
export const CLICK_SIZE = 8;

/** A frame's size when a click makes one, where no GUI pack says otherwise (board units). */
export const FRAME_SIZE = { w: 800, h: 600 } as const;

/** Room left around everything when the board is fitted (screen pixels). */
export const FIT_MARGIN_PX = 60;

/** How far (screen pixels) a drawn line's points may stray when it is simplified: it looks the same and stays small. */
export const INK_TOLERANCE_PX = 0.5;

/** The words' size (CSS pixels) when an item does not say. */
export const TEXT_SIZE = 18;

/** Where a kind's tool without an `order` stands: after the built-in packs' (which count in tens). */
export const LATE_ORDER = 500;

/** How often other pages' drags are looked at for staleness. */
export const STALE_CHECK_MS = 1000;

/** Room between the items {@link boardOf} lays out on a grid. */
export const GRID_GAP = 40;

/** How many items a row of the grid holds. */
export const GRID_COLUMNS = 6;

/** The smallest an item gets while resized. */
export const MIN_SIZE = 16;

/** How many steps a stroke's points are written in, across its box (`style.path`). */
export const INK_STEPS = 1000;

/** The width of a cell of the grid items without a place are laid out on (board units, before {@link GRID_GAP}). */
export const GRID_CELL = 240;

/** A turn with Shift held goes by steps of this many degrees. */
export const ROTATE_STEP_DEG = 15;
